import ApplicantCarousel from "../../../../../components/ABOProfile/ApplicantComponents/ApplicantCarousel/ApplicantCarousel";
import { useGetABOProfileQuery } from "../../../../../services/AboProfile/AboProfileAPI";
import { useAppSelector } from "../../../../../store";
import "./ABOProfileApplicantCarousel.scss";

const ABOProfileApplicantCarousel = () => {
  // Get Login ABO
  const affAbo = useAppSelector((state) => state.profile.affAbo);
  const isFromEdLos = useAppSelector((state) => state.profile.isFromEdLos);
  const [aff = "", abo = ""] = affAbo.split("-");
  const boot = useAppSelector(({ boot }) => boot);
  const profileInfo = boot?.configuration?.profile?.aboInfo || {};

  const { isFetching, data } = useGetABOProfileQuery({
    aff,
    abo,
    ...(isFromEdLos ? { includePlatinumAndAbove: true } : {}),
  });

  const applicantList = data?.partyInfo?.filter(({ isPrimary }) => isPrimary === false).slice(0, 2);

  return (
    <div className={`${applicantList && applicantList.length > 0 ? "abo-profile-applicants" : ""}`}>
      <ApplicantCarousel
        aboInfo={data?.aboInfo}
        partyInfo={applicantList}
        isFetching={isFetching}
        profileInfo={profileInfo}
      />
    </div>
  );
};

export default ABOProfileApplicantCarousel;
